import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import "../Menu.css";
import { resetPasswordRequest } from "../redux/actions/authAction";
import Footer from "./footer";
import Navbar from "./navbar";

const Lostpassword = () => {
	const dispatch = useDispatch();

	const [email, setEmail] = useState("");
	const [emailError, setEmailError] = useState("");
	const handleSubmit = (e) => {
		console.log("email", email);
		e.preventDefault();
		if (!email) {
			setEmailError("Email is required.");
			return;
		} else if (!/\S+@\S+\.\S+/.test(email)) {
			setEmailError("Email is invalid.");
			return;
		}
		dispatch(resetPasswordRequest({ email: email }));
	};

	return (
		<>
			<Navbar />
			<div id="testlogin" style={{ backgroundColor: "white" }}>
				<div className="spacer"></div>
				<div className="row">
					<div className="col-1"></div>
					<div className="col-10 block">
						<p className="heading-1">
							Please enter your email address. You will receive a link to create
							a new password via email.
						</p>
						<form autoComplete="off">
							<div className="row">
								<label className="email-label-3">
									Email address{" "}
									<span style={{ color: "rgb(114, 28, 36)" }}>*</span>
								</label>
								<div className="email-input-3">
									<input
										style={{ border: "1px solid #dee2e6" }}
										className="email-input-3"
										name="email"
										value={email}
										maxLength={200}
										onChange={(e) => setEmail(e.target.value)}
										type="email"
									/>
								</div>
								<p
									style={{
										visibility: emailError ? "visible" : "hidden",
									}}
									className="error-message ms-3">
									{emailError}
								</p>
							</div>

							<button
								className="GetNewpassword"
								onClick={handleSubmit}
								type="button">
								Get Link
							</button>
						</form>
					</div>

					<div className="col-1"></div>
				</div>
				<div className="row">
					<div className="col-1"></div>
					<div className="col-10 text-left join">
						<Link to="/login">
							<button className="Lost-button fw-bolder" type="button">
								Login
							</button>
						</Link>
						{" | "}
						<Link to="/register">
							<button className="Lost-button fw-bolder" type="button">
								Create Account
							</button>
						</Link>
					</div>
					<div className="col-1"></div>
				</div>
				<div className="spacer"></div>
			</div>
			<Footer />
		</>
	);
};
export default Lostpassword;
